import { useState, useEffect } from 'react';
import { differenceInSeconds, differenceInMinutes, differenceInHours, differenceInDays } from 'date-fns';

export const CountdownTimer = ({ targetDate, onComplete }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const target = new Date(targetDate);

    const calculateTimeLeft = () => {
      const now = new Date();
      
      if (now >= target) {
        setIsComplete(true);
        if (onComplete) onComplete();
        return;
      }

      const totalSeconds = differenceInSeconds(target, now);
      const days = differenceInDays(target, now);
      const hours = differenceInHours(target, now) % 24;
      const minutes = differenceInMinutes(target, now) % 60;
      const seconds = totalSeconds % 60;

      setTimeLeft({ days, hours, minutes, seconds });
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, [targetDate, onComplete]);

  if (isComplete) {
    return (
      <div className="text-[#FF3B30] uppercase tracking-widest text-sm font-medium" data-testid="countdown-complete">
        Available Now
      </div>
    );
  }

  return (
    <div className="flex space-x-4" data-testid="countdown-timer">
      <div className="countdown-box text-center">
        <span className="block text-2xl md:text-3xl font-bold font-['Syne']" data-testid="countdown-days">
          {String(timeLeft.days).padStart(2, '0')}
        </span>
        <span className="text-xs uppercase tracking-widest text-muted-foreground">Days</span>
      </div>
      <div className="countdown-box text-center">
        <span className="block text-2xl md:text-3xl font-bold font-['Syne']" data-testid="countdown-hours">
          {String(timeLeft.hours).padStart(2, '0')}
        </span>
        <span className="text-xs uppercase tracking-widest text-muted-foreground">Hours</span>
      </div>
      <div className="countdown-box text-center">
        <span className="block text-2xl md:text-3xl font-bold font-['Syne']" data-testid="countdown-minutes">
          {String(timeLeft.minutes).padStart(2, '0')}
        </span>
        <span className="text-xs uppercase tracking-widest text-muted-foreground">Min</span>
      </div>
      <div className="countdown-box text-center">
        <span className="block text-2xl md:text-3xl font-bold font-['Syne']" data-testid="countdown-seconds">
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
        <span className="text-xs uppercase tracking-widest text-muted-foreground">Sec</span>
      </div>
    </div>
  );
};
